import React from 'react'
import { formatTZLabel } from './helper'
import JsonDSTZones from './timezonesDST'
import moment from 'moment-timezone'

const convertTimezoneMinutesToHours = (minutes : number,noSemiColon?: boolean) => {
      const sign = minutes < 0 ? '-' : '+';
      const absMinutes = Math.abs(minutes);
      const hours = Math.floor(absMinutes / 60);
      const mins = absMinutes % 60;
      if(noSemiColon){
        return `${sign}${String(hours).padStart(2, '0')}${String(mins).padStart(2, '0')}`;
      }
      return `${sign}${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}

const DSTTimeZoneList = (date?: any,dstZone?: any,zoneOffset?: any,setZoneOffset?: any,onDone?: any) => {
  let tzs = [];
  let momentDate;
  
  // Use consistent date formatting instead of locale-dependent methods
  let dateString, timeString;
  if(date && date instanceof Date && !isNaN(date.getTime())) {
    // Format date as DD/MM/YYYY to match moment.js parser format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    dateString = `${day}/${month}/${year}`;
    
    // Format time as HH:mm:ss
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    timeString = `${hours}:${minutes}:${seconds}`;
  }


  if(date && date instanceof Date && !isNaN(date.getTime())) {
    momentDate = moment(date);
  }else{
    momentDate = moment();
  }

  let newLabel: any = '';
  let singleTZDiffOffset, singleTZHourOffset, singleTZMinOffset, offsetVal;
  for (var _i = 0; _i < JsonDSTZones.length; _i++) {
    offsetVal = '';


    let m;

    if(date && date instanceof Date && !isNaN(date.getTime())){
      const dateTime = `${dateString} ${timeString}`; // '02/11/2025 02:00:00'
      const format = 'DD/MM/YYYY HH:mm:ss';
      m = moment.tz(dateTime, format, JsonDSTZones[_i].value);
    }

    
    JsonDSTZones[_i].offset = (m && date && m?._isValid) ? convertTimezoneMinutesToHours(m._offset) : momentDate.tz(JsonDSTZones[_i].value).format("Z");


    if(date && date instanceof Date && !isNaN(date.getTime()) && m?._isValid) {
      newLabel = formatTZLabel(JsonDSTZones[_i].label, JsonDSTZones[_i].value, JsonDSTZones[_i].offset,m?.toDate().toISOString());
    }else{
      newLabel = formatTZLabel(JsonDSTZones[_i].label, JsonDSTZones[_i].value, JsonDSTZones[_i].offset);
    }

    singleTZDiffOffset = newLabel.charAt(5);
    singleTZHourOffset = parseInt(newLabel.substring(6, newLabel.indexOf(':')));
    singleTZMinOffset = parseInt(newLabel.substr(newLabel.indexOf(':') + 1, 2));
    offsetVal = parseInt(singleTZDiffOffset + '' + (singleTZHourOffset * 60 + singleTZMinOffset));


    
    if(date && dstZone === JsonDSTZones[_i].value){
      if(zoneOffset !== convertTimezoneMinutesToHours(offsetVal,true)){
        setZoneOffset(convertTimezoneMinutesToHours(offsetVal,true));
        onDone(timeString+convertTimezoneMinutesToHours(offsetVal,true),{
          // label: <Tooltip position="bottom" content={newLabel}>{newLabel}</Tooltip>,
          label: newLabel,
          value: JsonDSTZones[_i].value,
          alias: JsonDSTZones[_i].alias || [],
          offsetValue: offsetVal,
          offsetString: JsonDSTZones[_i].offset.replace(':', ''),
          searchKey: newLabel
        })
      }
    }


    tzs.push({
      // label: <Tooltip position="bottom" content={newLabel}>{newLabel}</Tooltip>,
      label: newLabel,
      value: JsonDSTZones[_i].value,
      alias: JsonDSTZones[_i].alias || [],
      offsetValue: offsetVal,
      offsetString: JsonDSTZones[_i].offset.replace(':', ''),
      searchKey: newLabel
    });
  }
  return tzs;
};
export default DSTTimeZoneList